/*

Ashraf  10/28/2022  2700430604 moved main tabs to header
Raghu 10/28/2022  2700430604 Card Styling Fixes
ashraf 10/30/2022 2700430604 conditional tabs render
Sohel 11/03/2022 2700430604 Tab name Changes
Rohini  12/05/2022 2700430604 changed side nav format
Ashraf 12/05/2022 2700430604 Fixed header labels

*/

import React from 'react';
import Tabs from './Tabs';
import LandingPage from '../../../Pages/LandingPage';

function Triggers() {
  const [value, setValue] = React.useState(0);

  // set Tab Value(2699758070)
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Batch Triggers'];

  return (
    <>
      <LandingPage title={'Triggers'} showTabs={true} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}>
        <div className={`global-field-dash-board`}>
          <div>
            <div>
              <Tabs value={value} />
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default Triggers;
